import React from 'react';
import { Box, styled } from '@mui/material';

interface CustomScrollbarProps {
  children: React.ReactNode;
  height?: string;
  maxHeight?: string;
  className?: string;
}

const ScrollableBox = styled(Box)<{ $height?: string; $maxHeight?: string }>(({ theme, $height, $maxHeight }) => ({
  height: $height || 'auto',
  maxHeight: $maxHeight || 'none',
  overflow: 'auto',
  scrollbarWidth: 'thin', // For Firefox
  scrollbarColor: `${theme.palette.grey[400]} transparent`, // For Firefox
  
  // Webkit scrollbar styles (Chrome, Safari, Edge)
  '&::-webkit-scrollbar': {
    width: '10px',
    height: '10px',
  },
  
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
    borderRadius: '6px',
    margin: '4px 0',
  },
  
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.grey[400],
    borderRadius: '6px',
    border: '2px solid transparent',
    backgroundClip: 'content-box',
    transition: 'background-color 0.2s ease',
    
    '&:hover': {
      background: theme.palette.grey[500],
      backgroundClip: 'content-box',
    },
    
    '&:active': {
      background: theme.palette.grey[600],
      backgroundClip: 'content-box',
    },
  },
  
  '&::-webkit-scrollbar-corner': {
    background: 'transparent',
  },
  
  // Custom scrollbar for horizontal scroll
  '&::-webkit-scrollbar:horizontal': {
    height: '10px',
  },
  
  // Ensure content doesn't overflow
  '& > *': {
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  
  // Smooth scrolling
  scrollBehavior: 'smooth',
}));

const CustomScrollbar: React.FC<CustomScrollbarProps> = ({ 
  children, 
  height, 
  maxHeight, 
  className 
}) => {
  return (
    <ScrollableBox 
      $height={height} 
      $maxHeight={maxHeight}
      className={className}
    >
      {children}
    </ScrollableBox>
  );
};

export default CustomScrollbar; 